// extracted by mini-css-extract-plugin
export default {"ingredient__container":"BurgerItem_ingredient__container__ySKOS"};